export default "__VITE_ASSET__f8hbOD4V__"